import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { ACMobileHubSpotLogo } from '../ACHubSpotLogo';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Button } from 'foundations-components/transitional/components/Button';
import { ACSearchInput } from '../ACSearchInput/ACSearchInput';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { List } from 'foundations-components/transitional/components/List';
import { useTabsConfig } from './hooks/useTabsConfig';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { FullScreenPanel } from '../FullScreenPanel';
import { CatalogPanel } from '../ACCatalog/CatalogPanel';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { FilterIcon } from 'foundations-assets/icons/components/FilterIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobilePage = ({
  children,
  isPartner
}) => {
  const tabs = useTabsConfig({
    isPartner
  });
  const [isCatalogOpen, setIsCatalogOpen] = useState(false);
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);
  const toggleNavigation = () => {
    setIsNavigationOpen(prev => !prev);
  };
  const toggleCatalog = () => {
    setIsCatalogOpen(prev => !prev);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    backgroundColor: "fill-surface-default",
    flexDirection: "column",
    minBlockSize: "100vh",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      padding: "400",
      children: [/*#__PURE__*/_jsx(Box, {
        alignSelf: "start",
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "navigation-button",
          use: "unstyled",
          responsive: false,
          onClick: toggleNavigation,
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            inlineSize: "100%",
            children: [/*#__PURE__*/_jsx(ACMobileHubSpotLogo, {}), /*#__PURE__*/_jsx(IconHolder, {
              icon: DownIcon
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        children: [/*#__PURE__*/_jsx(ACSearchInput, {}), /*#__PURE__*/_jsx(IconButton, {
          "data-test-id": "filter-button",
          onClick: toggleCatalog,
          paddingInline: "200",
          children: /*#__PURE__*/_jsx(FilterIcon, {})
        })]
      })]
    }), /*#__PURE__*/_jsx(Box, {
      backgroundColor: "fill-surface-recessed",
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(View, {
        blockSize: "100%",
        borderBlockStartColor: "border-core-default",
        borderBlockStartStyle: "solid",
        borderBlockStartWidth: "100",
        padding: "400",
        children: children
      })
    }), /*#__PURE__*/_jsx(FullScreenPanel, {
      isOpen: isNavigationOpen,
      onRemoveButtonClick: toggleNavigation,
      children: /*#__PURE__*/_jsx(List, {
        childStyles: {
          marginBlockStart: '400'
        },
        firstChildStyles: {
          marginBlockStart: '0'
        },
        wrapChildren: true,
        children: tabs.map(tab => /*#__PURE__*/_jsx(RouterLink, {
          onClick: toggleNavigation,
          to: tab.to,
          use: "unstyled",
          children: /*#__PURE__*/_jsx(Button, {
            block: true,
            use: "unstyled",
            children: /*#__PURE__*/_jsx(View, {
              inlineSize: "100%",
              textAlign: "start",
              children: tab.title
            })
          })
        }, tab.tabId))
      })
    }), /*#__PURE__*/_jsx(CatalogPanel, {
      isOpen: isCatalogOpen,
      onRemoveButtonClick: toggleCatalog
    })]
  });
};